import theme from '../themes/default'

const carouselHeight = Math.round(window.innerWidth * 0.4933333)

export default {
  wrap: {
    height: '100%',
    '& .swiper-container': {
      height: '100%',
    },
    '& .swiper-slide-prev': {
      transform: 'scale(0.95)',
    },
    '& .swiper-slide-active': {
      transform: 'scale(1)',
    },
    '& .swiper-slide-next': {
      transform: 'scale(0.95)',
    },
    '& .am-stepper-handler-up, .am-stepper-handler-down': {
      borderRadius: '50%',
      border: '2px solid #4A8CA1',
      '& .am-icon': {
        color: '#4A8CA1',
      },
    },
    '& .swiper-wrapper': {
      'padding-bottom': '10px',
    },
  },
  'carousel-block-wrap': {

  },
  'carousel-block': {
    color: '#000',
    background: '#fff',
    borderRadius: '8px 8px 8px 8px',
    'box-shadow': '0 4px 17px 0 rgba(160,156,156,0.36)',
    // 'height': `${ carouselHeight + 110 }px`,
    'margin-top': '10px',
    'padding-bottom': '5px',
  },
  'carousel-item-detail': {
    padding: '35px 10px 10px 10px',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  'carousel-item-cover-image-wrap': {
    borderRadius: '8px 8px 0px 0px',
    overflow: 'hidden',
  },
  'carousel-item-cover-image': {
    position: 'relative',
    width: '100%',
    margin: '-50% auto',
    'vertical-align': 'middle',
  },
  'carousel-item-name': {
    flex: 1,
    'font-size': '14px',
    'letter-spacing': '1px',
    color: '#614D4A',
    'font-weight': 'bold',
    lineHeight: '18px',
  },
  'carousel-item-sold-out-soon': {
    color: '#C54545',
    marginTop: '2px',
  },
  'carousel-item-price-wrap': {
    flexShrink: 0,
    display: 'flex',
    'justify-conent': 'center',
    'align-items': 'center',
    'text-align': 'right',
    minWidth: 40,
  },
  'carousel-price-discount-amount': {
    'font-size': '14px',
    color: '#555555',
    'font-weight': 'bold',
    'text-decoration': 'line-through',
    'margin-right': '4px',
    '& svg': {
      'font-size': '12px',
    },
  },
  'carousel-item-price-prefix': {
    display: 'flex',
    'justify-conent': 'center',
    'align-items': 'center',
    color: '#614D4A',
    'vertical-align': 'middle',
    height: '19px',
    'font-size': '12px',
  },
  'carousel-item-price': {
    'font-size': '19px',
    color: '#C54545',
    'font-weight': 'bold',
    'margin-left': '2px',
    display: 'inline-block',
  },
  'carousel-item-description': {
    'font-size': '10px',
    color: '#A59996',
    'padding-top': '3px',
    minHeight: '38px',
  },
  'carousel-stepper': {
    position: 'absolute',
    top: '-15px',
    background: '#fff',
    'box-shadow': '0 4px 17px 0 rgba(160,156,156,0.36)',
    padding: '3px 10px 2px 10px',
    borderRadius: '25px',
    'margin-left': 'auto',
    'margin-right': 'auto',
    left: '0',
    right: '0',
    width: '79px',
    '& .am-stepper': {
      height: '30px',
    },
    '& .am-stepper-handler': {
      width: '25px',
      height: '25px',
      'line-height': '25px',
    },
    '& .am-stepper-input-wrap': {
      '& .am-stepper-input': {
        'margin-bottom': '8px',
      },
    },
  },
  'carousel-promote-set-button': {
    color: '#fff',
    height: '35px',
    'text-align': 'center',
    width: '100%',
    'line-height': '35px',
    padding: '0 10px',
    background: '#4a8ca1',
    'align-items': 'center',
    borderRadius: '15px',
  },
  'carousel-find-more-button': {
    paddingTop: 8,
  },
}



// WEBPACK FOOTER //
// ./src/assets/styles/components/Carousel.js